import { TParsedCharacter } from '@lib/core/characters/utils/parseCharacter';
import { TProductCategory } from '@lib/core/products/types';

export const isCharacterByProductCategory = (character: TParsedCharacter, productCategory: TProductCategory): boolean =>
  character.characterProductCategory.name === productCategory;

export const isCharacterByIdentifiers = (character: TParsedCharacter, identifiers?: string[]): boolean =>
  identifiers?.includes(character.characterId);
